import type { Pack } from '../lib/types'

// Cover art with a deterministic generated fallback when no image is attached.
export default function PackArtwork({
  pack,
  size = 'mid',
  className = '',
}: {
  pack: Pick<Pack, 'name' | 'image' | 'catalog_number'>
  size?: 'thumb' | 'mid' | 'full'
  className?: string
}) {
  const src = pack.image?.[size] ?? null
  if (src) {
    return (
      <img
        src={src}
        alt={`${pack.name} cover art`}
        loading="lazy"
        className={`w-full h-full object-cover ${className}`}
      />
    )
  }

  // Generative placeholder (hairline grid) keyed to the pack name.
  const seed = pack.name.split('').reduce((a, c) => a + c.charCodeAt(0), 0)
  const rot = seed % 8
  return (
    <div
      className={`relative w-full h-full grid place-items-center bg-ink-soft overflow-hidden ${className}`}
      aria-label={`${pack.name} cover art`}
    >
      <svg viewBox="0 0 100 100" className="w-full h-full opacity-40" aria-hidden>
        {Array.from({ length: 9 }).map((_, i) => (
          <line key={`h${i}`} x1="0" y1={i * 12.5} x2="100" y2={i * 12.5} stroke="#404040" strokeWidth="0.4" />
        ))}
        {Array.from({ length: 9 }).map((_, i) => (
          <line key={`v${i}`} x1={i * 12.5} y1="0" x2={i * 12.5} y2="100" stroke="#404040" strokeWidth="0.4" />
        ))}
        <circle cx="50" cy="50" r={20 + (seed % 12)} fill="none" stroke="#737373" strokeWidth="0.6" transform={`rotate(${rot * 15} 50 50)`} />
      </svg>
      <span className="absolute mono-label !text-paper/70">{pack.catalog_number ?? pack.name}</span>
    </div>
  )
}
